import React from 'react';
import {useTranslation} from 'react-i18next';

import styles from './styles.scss';

export type LocalizedTextP = {
    name:string;
    path?:string;
    options?:object;
};

export const LocalizedText = ({name, path, options}:LocalizedTextP) => {
    const {t} = useTranslation(path);
    const localizedText = t(name, options);

    return <span className={styles.localizedText}>
        {localizedText || name}
    </span>;
};
